import React, { useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { StyledLoading, StyledIcon } from './styledLoading';
import messages from './messages';

export interface ILoadingProps {
  className?: string;
  shouldBeFullPageHeight?: boolean;
  shouldSmoothScrollToTop?: boolean;
}

const Loading = ({
  className,
  shouldBeFullPageHeight = false,
  shouldSmoothScrollToTop = false,
}: ILoadingProps): JSX.Element => {
  const { messages: intlMessages, formatMessage } = useIntl();
  const hasLoadingMessage = intlMessages?.['loading.loadingMessage'];
  const hasScrolled = useRef(false);

  useEffect(() => {
    if (shouldSmoothScrollToTop && typeof window !== 'undefined' && !hasScrolled.current) {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      hasScrolled.current = true;
    }
  }, [shouldSmoothScrollToTop]);

  return (
    <StyledLoading $shouldBeFullPageHeight={shouldBeFullPageHeight} className={className}>
      <StyledIcon title={hasLoadingMessage ? `${formatMessage(messages.loadingMessage)}&hellip;` : 'Loading…'} />
    </StyledLoading>
  );
};

export default Loading;
